<template>
  <site-menu />

  <slot></slot>

  <custom-whatsapp-button
    :telefone="t('NumeroWhatsapp')"
    :texto="t('TextoWhatsapp')"
  />

  <site-rodape />
</template>

<script>
export default {
  name: "DefaultLayout",
};
</script>

<script setup>
const { t } = useI18n();
</script>
